import { IconName } from '../icon/icon-name';

// Nine glyphs cover every OpenWeather condition: clear sky and few clouds have
// dedicated day/night variants; the rest share one glyph per two-digit prefix.
const DAY_NIGHT_GLYPHS = new Set(['01d', '01n', '02d', '02n']);
const SHARED_GLYPHS = new Set(['03', '04', '09', '10', '11', '13', '50']);

/** OpenWeather icon code ("10d", "01n", ...) → sprite icon name. */
export function weatherIconName(code: string): IconName {
  if (DAY_NIGHT_GLYPHS.has(code)) {
    return `weather-${code}` as IconName;
  }
  const prefix = code.slice(0, 2);
  return (SHARED_GLYPHS.has(prefix) ? `weather-${prefix}` : 'weather-03') as IconName;
}
